/* eslint-disable react/prop-types */
import { Dialog } from "primereact/dialog";

export default function Addandeditform ({visible, setVisible, formdata, handlechange, handlesave, handleupdate}) {

    return (
        <>
         <Dialog header="Notification Form" visible={visible} onHide={() => { if (!visible) return; setVisible(false); }} style={{ width: "50vw" }} breakpoints={{ "960px": "75vw", "641px": "100vw" }} maximizable >
        <form onSubmit={!formdata._id ? handlesave : handleupdate}>
          <div className="grid grid-cols-1 gap-y-2">
            <div>
              <div> <label>Notification Title</label> </div>
              <input type="text" name="Notification_Title" value={formdata["Notification_Title"]} className="w-full px-4 py-2 mt-1 border outline-none rounded-xl" onChange={handlechange} required />
            </div>
            <div>
              <div>
                <label>Notification Link</label>
              </div>
              <input type="text" name="Notification_Link" value={formdata["Notification_Link"]} className="w-full px-4 py-2 mt-1 border outline-none rounded-xl" onChange={handlechange} required />
            </div>
            <div>
              <div>
                <label>Notification Type</label>
              </div>
              <select name="Notification_type" className="w-full px-4 py-2 mt-1 border outline-none rounded-xl" onChange={handlechange} value={formdata.Notification_type} required >
                <option value="">---Select the Type---</option>
                <option value="General_Notification">General Notification</option>
                <option value="Academy_Notification">Academy Notification</option>
              </select>
            </div>
            <div>
              <div>
                <label>Status</label>
              </div>
              <select name="Status" className="w-full px-4 py-2 mt-1 border outline-none rounded-xl" onChange={handlechange} value={formdata.Status} required >
                <option value="">---Select a Status---</option>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
          
          </div>

          <div className="flex justify-end gap-5 mt-5">
            <button type="button" onClick={() => setVisible(false)}>
              Cancel
            </button>
            <button type="submit" className="px-4 py-2 text-white bg-secondary rounded-xl" >
              <i className="fi fi-br-check"></i>{" "}
              {!formdata._id ? "Save" : "Update"}
            </button>
          </div>
        </form>
      </Dialog>
        </>
    )
}